import { JobDetailsDrawer } from '@client/components/_business/jobs/JobDetailsDrawer';
import { PageController } from '@client/components/_core/layout/PageController';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

export const Route = createFileRoute('/admin-console/advanced/jobs/dynamic-recurring/$jobId')({
    staticData: {
        breadcrumb: { title: 'Dynamic recurring job details' },
        presentation: 'overlay',
        ui: {
            title: 'Dynamic recurring job details',
        },
    },
    component: DynamicRecurringJobDetail,
});

function DynamicRecurringJobDetail() {
    const { jobId } = Route.useParams();
    const navigate = useNavigate();
    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false);
        // Navigate back to the dynamic-recurring jobs list after drawer animation
        setTimeout(() => {
            navigate({ to: '/admin-console/advanced/jobs/dynamic-recurring' });
        }, 300);
    };

    return (
        <PageController route={Route}>
            <JobDetailsDrawer jobId={jobId} jobType="dynamic-recurring" open={open} onClose={handleClose} />
        </PageController>
    );
}
